
/* #Automatically detect user location and set currency
================================================== */
// function setCookie(key, value, expiry) {
//      var expires = new Date();
//      expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
//      document.cookie = key + '=' + value + ';max-age=' + expires.toUTCString() + ';path=/';
// }
// function getCookie(cname) {
//     var name = cname + "=";
//     var ca = document.cookie.split(';');
//     for(var i=0; i<ca.length; i++) {
//         var c = ca[i];
//         while (c.charAt(0)==' ') c = c.substring(1);
//         if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
//     }
//     return "";
// }

//  function setCurrencyInURLParameter(currencyCode) {
//         //sessionStorage.setItem('currency_set_by_user', 'yes');
//         setURLParameter('currency', currencyCode);
//     }

//     function setURLParameter(name, value) {
//         if (window.location.search) {
//             window.location.search = window.location.search + '&' + name + '=' + value;
//         } else {
//             window.location.search = '?' + name + '=' + value;
//         }
//     }

//  function getCookieValue(cookieName) {
//         var cookiesArray = document.cookie.split(';');
//         var cookieValue = '';
//         cookieName = cookieName + '=';

//         for (var i = 0; i < cookiesArray.length; i++) {
//             var value = cookiesArray[i].trim();

//             if (value.indexOf(cookieName) === 0) {
//                 cookieValue = value.substring(cookieName.length, value.length);
//                 break;
//             }
//         }

//         return cookieValue;
//     }

// //checkCookie();
// setCurrency();
// function checkCookie() {
//     var currency_set = getCookieValue("currency_set");
//     console.log("Cookie Set "+ currency_set);
//     if (currency_set != "set") { // Cookie not set
//        console.log("Cookie Not Set "+ currency_set);
//         setCurrency();
//         setCookie("currency_set", "set", 7);
//     }
// }

// function setCurrency() {
// var currency = {"AU":"AUD", "CA":"CAD", "GB": "GBP", "JP":"JPY", "US":"USD"};
// fetch('https://ipinfo.io/json')
//   .then(function(response) {
//     return response.json();
//   })
//   .then(function(location) {
//     console.log(location);
//      var userCurrency = currency[location.country] ? currency[location.country] : "EUR" ;
//      console.log("Currency is " + userCurrency);
//      setCookie('cart_currency', userCurrency, '1');
//      setCurrencyInURLParameter(userCurrency);
//   });
// }



    var currency = {"GB": "GBP", "US":"USD"};

    var defaultCurrency = 'GBP';
    var hasUserAlreadySetCurrency = sessionStorage.getItem('currency_set_by_user') === 'yes';
    var cartCurrency = getCookieValue('cart_currency');

    //sessionStorage.removeItem('currency_set_by_user');

    // if (!hasUserAlreadySetCurrency) {
    //     if (cartCurrency === defaultCurrency) {
    //         var urlParameters = getURLParameters();
    //
    //         if (urlParameters.currency) {
    //             sessionStorage.setItem('currency_set_by_user', 'yes');
    //         }
    //     } else {
    //         sessionStorage.setItem('currency_set_by_user', 'yes');
    //     }
    // }

    hasUserAlreadySetCurrency = sessionStorage.getItem('currency_set_by_user') === 'yes';

    if (!hasUserAlreadySetCurrency && cartCurrency === defaultCurrency) {
        console.log("User has not set currency");
        // var httpRequest = new XMLHttpRequest();
        //
        // httpRequest.onreadystatechange = function() {
        //     if (4 === this.readyState && 200 === this.status) {
        //         var json = JSON.parse(this.responseText);
        //
        //         console.log(json);
        //
        //         var userCurrency = currency[json.country] ? currency[json.country] : defaultCurrency;
        //         setCurrencyInURLParameter(userCurrency);
        //
        //     }
        // }
        // httpRequest.open('GET', 'https://ipinfo.io/json?token=479cfd59630a51', false);
        // httpRequest.setRequestHeader('Accept', 'application/json');
        // httpRequest.send();

        if (navigator.userAgent.match(/bot|spider/i)) {
            //Request is a bot, do nothing
            console.log("I am a bot");
        } else {
            console.log("I am a human");
            fetch('https://ipinfo.io/json?token=479cfd59630a51')
                .then(res => res.json())
                .then(data => {
                  console.log('Success:', data);
                  console.log("Country is " + data.country);
                  var userCurrency = currency[data.country] ? currency[data.country] : defaultCurrency;
                  console.log("Currency is " + userCurrency)
                  setCurrencyInURLParameter(userCurrency);
                })
                .catch((error) => {
                  console.error('Error:', error);
                });
        }
    }
    else {
      console.log("User has set currency");
    }

    function getCookieValue(cookieName) {
        var cookiesArray = document.cookie.split(';');
        var cookieValue = '';
        cookieName = cookieName + '=';

        for (var i = 0; i < cookiesArray.length; i++) {
            var value = cookiesArray[i].trim();

            if (value.indexOf(cookieName) === 0) {
                cookieValue = value.substring(cookieName.length, value.length);
                break;
            }
        }

        return cookieValue;
    }

    function getURLParameters() {
        var params = {};
        var regex = /[?&]([^=#]+)=([^&#]*)/g;
        var url = window.location.href;
        var match;

        while (match = regex.exec(url)) {
            params[match[1]] = match[2];
        }

        return params;
    }

    function setCurrencyInURLParameter(currencyCode) {
        sessionStorage.setItem('currency_set_by_user', 'yes');
        setURLParameter('currency', currencyCode);
    }

    function setURLParameter(name, value) {
        if (window.location.search) {
            window.location.search = window.location.search + '&' + name + '=' + value;
        } else {
            window.location.search = '?' + name + '=' + value;
        }
    }
